function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 32C24.8365 32 32 24.8366 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
  fill: "url(#paint0_linear_10202_37100)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.606 16.0267C29.606 12.8026 28.4689 9.69894 26.3819 7.2374L28.1076 5.51165L26.4755 3.87954L24.7498 5.60529C19.6528 1.2976 12.1879 1.32436 7.13107 5.67218L5.40532 3.93305L3.75984 5.56516L5.49897 7.30429C4.6294 8.34777 3.92037 9.51164 3.39863 10.7692H5.75315C8.65615 5.12369 15.5859 2.88957 21.2448 5.79258C26.9036 8.69559 29.1244 15.6254 26.2347 21.2842C23.3451 26.9431 16.402 29.1638 10.7431 26.2742C8.58926 25.1638 6.83676 23.4113 5.73977 21.2575H3.38525C3.92037 22.5417 4.65616 23.7458 5.55248 24.816L3.82673 26.5417L5.45883 28.1738L7.18458 26.4347C12.2281 30.7023 19.6127 30.729 24.6963 26.5016L26.422 28.2274L28.0541 26.5953L26.3418 24.8695C28.4555 22.408 29.606 19.2642 29.606 16.0267Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.26501 19.184L5.92722 17.1505H7.85364V16.388H1.52588V17.1505H3.4523L2.11451 19.184H3.11785L4.69645 16.8027L6.27504 19.184H7.26501ZM7.85364 15.6388V14.8629H5.96735L7.29176 12.8562H6.28842L4.69645 15.2776L3.10447 12.8562H2.10113L3.42554 14.8629H1.52588V15.6388H7.85364Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8662 20.3744L13.1906 18.3008C14.1538 19.0099 14.903 19.3042 15.6522 19.3042C16.5485 19.3042 16.8963 18.9965 16.8963 18.3008C16.8963 16.8694 12.2943 16.6821 12.2943 13.5517C12.2943 11.3711 13.7793 10.0199 16.1873 10.0199C17.7525 10.0199 18.8629 10.662 19.7324 11.5851L18.2207 13.3376C17.5786 12.7624 17.0301 12.4814 16.3612 12.4814C15.5986 12.4814 15.2241 12.6955 15.2241 13.4045C15.2241 14.7557 19.8261 14.8359 19.8261 18.0734C19.8261 20.1737 18.4749 21.7523 15.6522 21.7523C14.5819 21.7657 12.9364 21.3376 11.8662 20.3744ZM14.6221 8.28076H17.3645V10.9563H14.6221V8.28076ZM14.6221 20.4814H17.3645V23.5182H14.6221V20.4814Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_10202_37100",
  x1: 26.572,
  y1: 26.7978,
  x2: 5.21877,
  y2: 5.00495,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#545AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2416,
  stopColor: "#585EFF",
  stopOpacity: 0.9905
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5034,
  stopColor: "#626BFF",
  stopOpacity: 0.9803
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7737,
  stopColor: "#7481FF",
  stopOpacity: 0.9697
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8799FF",
  stopOpacity: 0.9608
})));

function SvgXUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXUsd);
export default __webpack_public_path__ + "static/media/xUSD.f5be60f2d6db549760d11c405d0b0a42.svg";
export { ForwardRef as ReactComponent };